const METHOD_CONFIG = Object.freeze({
  yuhasz: { mode: "two_components", label: "Dos componentes · Yuhasz", chart: "somatocarta" },
  durnin_siri: { mode: "two_components", label: "Dos componentes · Durnin + Siri", chart: "somatocarta" },
  rfm: { mode: "two_components", label: "Masa grasa relativa", chart: "somatocarta" },
  sumatoria_pliegues: { mode: "sums", label: "Sumatoria de pliegues", chart: "somatocarta" },
  cinco_componentes: { mode: "five_components", label: "Cinco componentes · Ross & Kerr", chart: "somatocarta" },
});

export const ASSESSMENT_REPORT_VERSION = "1.0.0";

export function normalizeAssessmentPopulation(value) {
  return String(value || "").toLowerCase() === "pediatric" ? "pediatric" : "adult";
}

export function normalizeAssessmentMethod(value) {
  const method = String(value || "").trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(METHOD_CONFIG, method) ? method : "yuhasz";
}

export function selectAssessmentReportConfig({ populationProfile = "adult", method = "yuhasz", sequenceNumber = 1 } = {}) {
  const normalizedMethod = normalizeAssessmentMethod(method);
  const population = normalizeAssessmentPopulation(populationProfile);
  const config = METHOD_CONFIG[normalizedMethod];
  const sequence = Math.max(1, Number(sequenceNumber) || 1);
  return {
    id: `${population}_${config.mode}_${sequence === 1 ? "initial" : "control"}`,
    populationProfile: population,
    populationLabel: population === "pediatric" ? "Pediátrico" : "Adulto",
    method: normalizedMethod,
    methodLabel: config.label,
    mode: config.mode,
    visit: sequence === 1 ? "initial" : "control",
    visitLabel: sequence === 1 ? "Valoración inicial" : `Control ${sequence - 1}`,
    charts: [config.chart],
    formulaProfile: "legacy_excel_2026",
    formulaVersion: ASSESSMENT_REPORT_VERSION,
    note: population === "pediatric"
      ? "Perfil pediátrico seleccionado; confirma que las referencias antropométricas del formato actualizado correspondan a la edad del paciente."
      : "Perfil adulto seleccionado; se aplican las fórmulas del formato actualizado.",
  };
}

export function buildAssessmentComparison(current, previous) {
  if (!current || !previous) return { available: false, metrics: [] };
  const currentResults = current.results || {};
  const previousResults = previous.results || {};
  const candidates = [
    ["IMC", currentResults.bmi, previousResults.bmi, "kg/m²"],
    ["Grasa corporal", currentResults.primaryComposition?.fatPercent, previousResults.primaryComposition?.fatPercent, "%"],
    ["Masa libre de grasa", currentResults.primaryComposition?.leanKg, previousResults.primaryComposition?.leanKg, "kg"],
    ["Masa muscular", currentResults.primaryComposition?.muscleKg, previousResults.primaryComposition?.muscleKg, "kg"],
  ];
  return {
    available: true,
    metrics: candidates
      .filter(([, currentValue, previousValue]) => Number.isFinite(Number(currentValue)) && Number.isFinite(Number(previousValue)))
      .map(([label, currentValue, previousValue, unit]) => ({
        label,
        current: Number(currentValue),
        previous: Number(previousValue),
        delta: Number(currentValue) - Number(previousValue),
        unit,
      })),
  };
}

